import React from "react";
import { Outlet } from "react-router-dom";
import { Container } from "react-bootstrap";

const IqamaComponent = () => {
  return (
    <div className="iqama-component">
      <Container fluid>
        <Outlet />
      </Container>
    </div>
  );
};
export default IqamaComponent;
